import React from 'react';
import PropTypes from "prop-types";
import Table from "../../../common/components/Table/Table";
import {Button, Checkbox} from "semantic-ui-react";
import {connect} from "react-redux";
import DataProvidersListRow from "./DataProvidersListRow";
import {dpTableSearch, setDPListFilters, toggleDPSort, updateDPListFilters} from "../actions/DataProviderActions";
import {DPSortFields} from "../constants/DataProviderActionConstants";
import {Filter} from "../../../common/components/Filter";
import {TableSearch} from "../../../common/components/TableSearch";

export class DataProvidersTable extends React.Component {

    static propTypes = {
        DataProviders: PropTypes.array,
    }

    handleSort = (sortKey) => {
        this.props.changeDPSort(sortKey);
    }

    handleDPCountryFilter = (filterOption) => {
        this.props.setDPListFilters(filterOption, "country");
        this.props.updateDPListFilters();
    }

    handleDPTableSearch = (e) => {
        this.props.typeAheadSearchDP(e.target.value)
    }

    get tableHeaders() {
        const headers = [
            <Table.Header key="checkbox">
                <Checkbox
                    disabled
                />
            </Table.Header>,
            <Table.Header key="approved"> </Table.Header>,
            <Table.Header key="name"
                          sortKey={DPSortFields.PROVIDER_NAME}
                          className={"filterable-header"}>
                <span className={"header-text"}>Name</span>
                    <Filter
                        isIcon
                        isMulti
                        handleFilter={this.handleDPCountryFilter}
                        options={this.props.dpFilterOptionsObj.countryOptions}
                        value={this.props.dpFilters.countryFilter}
                    />
            </Table.Header>,
            <Table.Header key="services">Services</Table.Header>,
            <Table.Header key="sources">Sources</Table.Header>,
        ];
        return headers.filter(header => header !== null);
    }

    get tableItems() {
        return this.props.DataProviders.map(provider => (
            <DataProvidersListRow
                key={provider.provider_id}
                providerID={provider.provider_id}
                isApproved={provider.is_approved}
                providerName={provider.provider_name}
                associatedServices={provider.associated_services}
                associatedSources={provider.associated_sources}
                associatedCountries={provider.associated_countries}
            />
        ));
    }

    render() {
        return (
            <div>
                <div style={{padding: "20px 20px 0 30px"}}>
                    <Button
                        disabled={true}
                        icon="file pdf outline" size="big"
                    />
                    <Button
                        icon="file excel outline" size="big"
                        disabled={true}
                    />
                </div>
                <div className="data-services-list-container">
                    <TableSearch
                        handleSearch={this.handleDPTableSearch}
                    />
                    <div className="sticky-table-container">
                        <Table
                            className="sticky-table sortable"
                            currSortKey={this.props.dpSortKey}
                            sortDirection={this.props.dpSortDirection}
                            headers={this.tableHeaders}
                            onSort={this.handleSort}
                        >
                            {this.tableItems}
                        </Table>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    all_organizations: state.veritas.providers.all_organizations,
    filtered_all_organizations: state.veritas.providers.filtered_all_organizations,
    dpSortKey: state.veritas.providers.dpSortKey,
    dpSortDirection: state.veritas.providers.dpSortDirection,
    dpFilterOptionsObj: state.veritas.providers.dpFilterOptionsObj,
    dpFilters: state.veritas.providers.dpFilters,
});

const mapDispatchToProps = dispatch => ({
    changeDPSort: (sortKey) => {dispatch(toggleDPSort(sortKey))},
    setDPListFilters: (filterOption, type) => {dispatch(setDPListFilters(filterOption, type))},
    updateDPListFilters: () => {dispatch(updateDPListFilters())},
    typeAheadSearchDP: (value) => {dispatch(dpTableSearch(value))}
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DataProvidersTable)
